import * as fromDatatype from '../datatype-library';

export interface bl_pricing_scheme_copy_processor_status_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  pricing_hdr_guid: fromDatatype.GuidDataFieldInterface;
  short_error_message: fromDatatype.VarcharDatatypeInterface;
  error_stack_trace: fromDatatype.TextDatatypeInterface;
  processing_status: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_pricing_scheme_copy_processor_status_hdr_RowClass implements bl_pricing_scheme_copy_processor_status_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  pricing_hdr_guid: fromDatatype.GuidDataFieldInterface;
  short_error_message: fromDatatype.VarcharDatatypeInterface;
  error_stack_trace: fromDatatype.TextDatatypeInterface;
  processing_status: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}
